<template>
	<div id="app">
		<div class="preprod" v-if="isPreprod">You are currently using the pre-production version.</div>
		<transition name="fade" mode="out-in">
			<router-view class="app-view" />
		</transition>
	</div>
</template>

<script>

export default {
	name: 'App',

	computed: {
		isPreprod () {
			return window.location.origin === 'https://dashboard.designerbrands.shiseido.not.live'
		}
	}
}
</script>

<style lang="scss">
@use "./assets/styles/app";

.preprod {
	background: #c80421;
	color: #fff;
	text-align: center;
	padding: 5px;
}

.preprod + .app-view {
	height: calc(100% - 28px)
}
</style>



// WEBPACK FOOTER //
// src/App.vue